import { render, staticRenderFns } from "./employeecount.vue?vue&type=template&id=47271bd2&scoped=true&"
import script from "./employeecount.vue?vue&type=script&lang=js&"
export * from "./employeecount.vue?vue&type=script&lang=js&"
import style0 from "./employeecount.vue?vue&type=style&index=0&id=47271bd2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47271bd2",
  null
  
)

export default component.exports